import React from 'react';

export default (label) =>
  ({ note, ...props }) =>
    (
      <label {...props}>
        {label}
        <em display-if={note}> ({note})</em>
      </label>
    );
